import type { InvitationOperationResult as GraftInvitationOperationResult } from '@graft/nuget-gc.webportals.memberships'

import { readGraftObject } from '@common/utils/readGraftObject'

import type { InvitationOperationResult } from '@modules/memberships/memberships.type'

export async function mapGraftInvitationOperationResult(
  result: GraftInvitationOperationResult
): Promise<InvitationOperationResult> {
  const dto = await readGraftObject<InvitationOperationResult>(result)

  return {
    succeeded: Boolean(dto.succeeded),
    outcome: String(dto.outcome ?? ''),
    message: String(dto.message ?? ''),
    invitationId: String(dto.invitationId ?? ''),
    operationId: String(dto.operationId ?? ''),
  }
}
